import { render, staticRenderFns } from "./MatchPhaseSelect.vue?vue&type=template&id=248b5c82&scoped=true&"
import script from "./MatchPhaseSelect.vue?vue&type=script&lang=js&"
export * from "./MatchPhaseSelect.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/match-phase-select.scss?vue&type=style&index=0&id=248b5c82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248b5c82",
  null
  
)

export default component.exports